import { Container, FullRow, Title } from "./components"
import {
  AddressInterface,
  OrderStatusType,
  PickupInfoInterface,
  PriceInterface,
  UserActionInterface,
  UserInSessionInterface,
} from "./types"
import axios from "axios"
import { message } from "antd"
import CryptoJS from 'crypto-js'

declare var process: {
  env: {
    NODE_ENV: string
    REACT_APP_OUTPUT_SERVER_PORT: string | undefined
    REACT_APP_STRIPE_PUBLIC_KEY: string | undefined
    REACT_APP_RECAPTCHA_SITE_KEY: string | undefined
  }
}

const environment = process.env.NODE_ENV as string
// console.log("process.env")
// console.log(process.env)

let api_base = ""
let basename = ""

// if (process.env.REACT_APP_OUTPUT_SERVER_PORT===undefined){
//   api_base="/gsapi/api"
//   basename='/genes'
// }else
if (!environment || environment === "development") {
  api_base = "/api"
  basename = "/"
} else {
  api_base = "https://www.plabsequencing.com/api"
  basename = "/"
}
api_base = "/api"
basename = "/"
// api_base="/api"
// basename='/genes'

// console.log(basename)

//The BASENAME is used for react router, otherwise you  get a blank page
//in homepage in package.json, it is used to build the production
export const BASENAME = basename

export const API_BASE = api_base
export const OUTPUT_SERVER_PORT = 7281

export function consolelog(name: string, value: any) {
  console.log(name)
  console.log(value)
}




const axiosp = axios.create({
    withCredentials: true,
    // baseURL: API_BASE, // Optionally set baseURL here
})

const SESSION_REDIRECT_FLAG = "session-timeout-redirecting"
let isSessionRedirectInProgress = false

function redirectToHomeAndRefresh() {
  if (isSessionRedirectInProgress) return
  isSessionRedirectInProgress = true

  try {
    sessionStorage.setItem(SESSION_REDIRECT_FLAG, "1")
  } catch (e) {
    // Ignore storage errors and continue redirect.
  }

  const target = `/?sessionExpired=${Date.now()}`
  window.location.href = target
  // Fallback refresh in case SPA navigation races with async state updates.
  window.setTimeout(() => window.location.reload(), 60)
}

function isSessionExpiredResponse(data: any): boolean {
  if (!data || typeof data !== "object") return false
  const msg = String(data.message ?? "").toLowerCase()
  const code = Number(data.code)

  if (code === 1006 || code === 1090) return true
  if (msg.includes("session out") || msg.includes("please log in first")) return true

  // Some guarded routes return generic permission-denied when session expired.
  if ((code === 1091 || code === 1092) && msg.includes("permission denied")) return true

  return false
}

axiosp.interceptors.response.use(
  response => {
    if (isSessionExpiredResponse(response?.data)) {
      redirectToHomeAndRefresh()
      return new Promise(() => {})
    }
    return response
  },
    error => {
    if (isSessionExpiredResponse(error?.response?.data)) {
      redirectToHomeAndRefresh()
      return new Promise(() => {})
    }

        // Check if this request should suppress error messages
        const suppressError = error?.config?.metadata?.suppressError
        
        if (!suppressError) {
            console.error("Global Axios error:", error)
            message.error(error?.response?.data?.message || error.message)
        } else {
            // For suppressed errors, only log a minimal notice
            console.debug("Suppressed axios error for:", error?.config?.url)
        }
        return Promise.reject(error)
    }
)

export const axiosApi=axiosp

const bcrypt = require("bcryptjs")
//use the slower and safer bcrypt algorithm to hash the password
export async function hashPassword(password: string): Promise<string> {
  const saltRounds = 11 // Number of salt rounds (higher is more secure but slower)
  // console.log('bcrypt hashing',password,' len:',password.length)
  const salt = bcrypt.genSaltSync(saltRounds)
  const hashedPassword = await bcrypt.hash(password, salt)
  return hashedPassword
}

// const Crypto = require("crypto")
//or import * as Crypto from "crypto";

export async function sha256(input: string) {
  // For development, use crypto-js directly to avoid Web Crypto API issues
  const hash = CryptoJS.SHA256(input)
  const base64Hash = CryptoJS.enc.Base64.stringify(hash)
  return base64Hash
}

export function decodeHttpSafe(encodedMessage: string) {
  // Reverse URL-safe encoding
  let base64 = encodedMessage.replace(/-/g, "+").replace(/_/g, "/")
  // Add padding if necessary
  while (base64.length % 4 !== 0) {
    base64 += "="
  }
  // Decode Base64 back to text
  return atob(base64)
}

export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI" // fallback to test key

export const SERVER_PUBLIC_KEY = `
 -----BEGIN RSA PUBLIC KEY-----
MIIBCgKCAQEAoJeOnm1FKLgIqcoBmxkiKeFTFaLZ/PWiYt60iiucbYZM7X3DSQ5u
9ZzSRxKOT77g81i1rkTi5fL8E7zezIHcFW+nW0JzMWWbvy0DrWsdqqgjonnxcIj4
ICM4GP0qAMUqfpdZaKhLNU4gbQDdNUbrk8E2XAqa+/karuBYwMaptzka0hBG01mj
wW6dBYIQqoHbzYCYiLak+4bNG3hkZdGWNo4/tkJ593DZUFigdD2MUqLbPRcPV/He
13EuYo/IgBFGN79QQ99Ah5m83/xZ2U+EYNclkCTKR6e1CefWcxi0Z/2HhKUBQJqT
H+YdVZx4QtG1zksJccdY0a5ysJcdXqAumwIDAQAB
-----END RSA PUBLIC KEY-----`

export const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY ||
  "pk_test_51Qa7fcKruTJnGMm5DZYeHHKoroFJuSb4TKJnpDsWcXD6Z3oJfh0MvaMpIXEmjmijU2qcsToavKU3v1W54UQnghtT00SmCa7kC2"

export const AllStates = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
]

export function httpsafe(text: string) {
  return text // Standard Base64
    .replace(/\+/g, "-") // Replace + with -
    .replace(/\//g, "_") // Replace / with _
    .replace(/=+$/, "") // Remove padding =
}

export function ShowMessagePage(
  title: string,
  content: string
): JSX.Element {
  // const m = btoa(
  //   JSON.stringify({
  //     title: title,
  //     content: content,
  //   })
  // )
  // navigate("/message?q=" + httpsafe(m))
  return (
    <Container>
      <FullRow>
        <Title>{title}</Title>
      </FullRow>
      <FullRow>{content}</FullRow>
    </Container>
  )
}

export const images = require.context("./images", false, /\.(png|jpe?g|svg)$/)
export const Country = "USA"
export const Currency = "USD"

export function getPrice(
  priceList: PriceInterface[] | undefined
): number | undefined {
  if (!priceList) return 0
  return priceList.find((x) => x.country === Country && x.unit === Currency)
    ?.price
}

export const refreshSessionUser = (
  userInfo: UserInSessionInterface,
  dispatch: React.Dispatch<UserActionInterface> | null
) => {
  console.log(" refresh user")
  dispatch?.({
    type: "UPDATE_USER",
    payload: userInfo,
  })
}

export const emptyaddress: AddressInterface = {
  line1: "",
  line2: "",
  city: "",
  state: "",
  country: "USA",
  zip: "",
}

export const pickupInfoInitialValue: PickupInfoInterface = {
  contactPerson: "",
  phone: "",
  specialInstructions: "",
  ...emptyaddress,
}

export const OrderStatus:{value:OrderStatusType, label:string}[]=[
  {value:"new",label:"Not shipped"},
  {value:"received",label:"Received"},
  {value:"running",label:"Running"},
  {value:"completed",label:"Completed"},
  {value:"canceled",label:"Cancelled"},
  {value:"rerun-requested",label:"Rerunning Requested"},
  {value:"rerun-canceled",label:"Rerun Cancelled"},
  {value:"rerun-completed",label:"Rerun Completed"}
]


export const ORDER_STATUS_COLORS: Record<string, string> = {
    new: "LightSkyBlue",
    received: "CornflowerBlue",
    running: "SpringGreen",
    completed: "MediumAquamarine",
    canceled: "Linen",
    "review-requested": "Gold",
    "rerun-completed": "MediumAquamarine",
    "review-completed": "MediumAquamarine",
    "": "Gray",
}


export const PLATE_STATUS_COLORS: Record<string, string> = {
    normal: "lightgreen",
    canceled: "Gold",
    
    "": "Gray",
}


export const SAMPLE_STATUS_COLORS :  Record<string, string>={
    "new": "LightSkyBlue",
    "completed": "MediumAquamarine",
    "review-requested": "Gold",
    "review-completed": "MediumAquamarine",
    "rerun-completed": "MediumAquamarine",
    "": "Gray",
}


// export type RunStatusType = "new" | "running" | "completed" | "canceled"
// export type RunStatusType = "new" | "received" | "running" | "completed" | "canceled" |"review-requested" | "review-completed" | "rerun-completed"
